export { default as useCacheLifestyle } from './useCacheLifestyle';
